import manifest from '../config/serviceSessionVisualManifest.json';

const GROUPS = manifest.groups || [];
const HEROES = manifest.heroes || {};
const BASE = String(manifest.basePath || '/salon/service-session').replace(/\/$/, '');

function norm(s) {
  return String(s || '').trim().toLowerCase();
}

function groupImagePaths(groupId) {
  const id = norm(groupId);
  if (!id) return { tab: '/no-image.png', card: '/no-image.png' };
  return {
    tab: `${BASE}/tabs/${id}.webp`,
    card: `${BASE}/cards/${id}.webp`,
  };
}

/** Stable filename per catalog service line (one card image per distinct name). */
export function serviceCardSlug(name) {
  const slug = String(name || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 80);
  return slug || 'service';
}

export function serviceSessionCardPath(service, categoryLabel = '') {
  const fromSvc = String(service?.card_slug || service?.cardSlug || '').trim();
  const name = service?.name || service?.service_name || '';
  const slug = fromSvc || serviceCardSlug(name);
  return `${BASE}/cards/services/${slug}.webp`;
}

function matchGroup({ category = '', name = '' } = {}) {
  const cat = norm(category);
  const nameLow = norm(name);
  for (const group of GROUPS) {
    const cats = (group.categories || []).map(norm);
    if (cat && cats.includes(cat)) return group.id;
    const keys = (group.nameKeywords || []).map(norm);
    if (nameLow && keys.some((k) => k && nameLow.includes(k))) return group.id;
  }
  for (const group of GROUPS) {
    const cats = (group.categories || []).map(norm);
    if (cat && cats.some((c) => c && (cat.includes(c) || c.includes(cat)))) return group.id;
  }
  return 'hair_cuts';
}

export function resolveServiceVisualGroupId(service, categoryLabel = '') {
  const category = service?.category || categoryLabel;
  const name = service?.name || '';
  const fromSvc = String(service?.visual_group || service?.visualGroup || '').trim();
  if (fromSvc) return fromSvc;
  return matchGroup({ category, name });
}

export function serviceSessionTabThumb(group) {
  const label = String(group?.category || '').trim();
  const first = (group?.items || [])[0];
  const fromSvc = String(
    first?.tab_thumb || first?.tabThumb || first?.image || first?.image_url || '',
  ).trim();
  if (fromSvc) return fromSvc;
  // Menu tab art is one image per rate-card category (not per service line).
  const id = matchGroup({ category: label, name: '' });
  return groupImagePaths(id).tab;
}

export function serviceSessionCardImage(service, categoryLabel = '') {
  const explicit = String(
    service?.card_image ||
      service?.cardImage ||
      service?.image ||
      service?.image_url ||
      service?.thumbnail ||
      '',
  ).trim();
  if (explicit) return explicit;
  if (String(service?.name || service?.service_name || '').trim()) {
    return serviceSessionCardPath(service, categoryLabel);
  }
  const id = resolveServiceVisualGroupId(service, categoryLabel);
  return groupImagePaths(id).card;
}

export function serviceSessionHeroImage(gender) {
  const g = norm(gender);
  if (g === 'female' || g === 'f') return HEROES.female || HEROES.default;
  if (g === 'male' || g === 'm') return HEROES.male || HEROES.default;
  return HEROES.default || HEROES.female;
}

export function listServiceSessionVisualGroups() {
  return GROUPS.map((g) => ({ id: g.id, categories: g.categories }));
}

export { manifest as serviceSessionVisualManifest };
